import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-input shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",

        /* --- Botones de marca VONDI (BRAND.md §6, manual §14) ---
           Se agregan como variantes nuevas, sin tocar las de shadcn, para que
           ninguna pantalla existente cambie de aspecto sin pedirlo. */

        /* Primario: gradiente vivo, texto blanco, esquinas muy redondeadas,
           sombra cálida difusa. */
        vondi:
          "bg-grad-vivo text-white rounded-full font-semibold shadow-warm transition-shadow hover:shadow-warm-lg",

        /* Identidad (QR): fondo negro con borde en degradado rojo→rosa. Así el
           color de marca también vive sobre superficies oscuras. */
        vondiIdentidad:
          "vd-btn-identidad text-white rounded-full font-semibold transition-shadow hover:shadow-warm",

        /* Secundario: fondo blanco, borde y texto en color de marca. */
        vondiSecundario:
          "bg-white text-vd-naranja border border-vd-naranja rounded-full font-semibold transition-colors hover:bg-vd-niebla",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
        /* Pastilla de marca: los botones de VONDI son pill (BRAND.md §4). */
        pill: "h-12 px-7 text-base",
        pillSm: "h-10 px-5 text-sm",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
